import { rem, rgba } from 'polished';
import { color } from './colors';

export const boxShadow = {
  small: `0 0 ${rem(6)} ${rgba(color.black, 0.08)}`,
  default: `0 ${rem(2)} ${rem(6)} ${rgba(color.black, 0.16)}`,
  primary: `0 0 0 ${rem(3)} ${rgba(color.primary, 0.25)}`,
  categories: `0 ${rem(38)} ${rem(29)} ${rgba(color.black, 0.35)}`,
};
